// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-body {\n  position: relative;\n}\n.card-body .pie-text {\n  width: 105px;\n  position: absolute;\n  top: 44%;\n  bottom: 0;\n}\n[dir] .card-body .pie-text {\n  margin: auto;\n}\n[dir=ltr] .card-body .pie-text {\n  left: 0;\n  right: 0;\n}\n[dir=rtl] .card-body .pie-text {\n  right: 0;\n  left: 0;\n}", ""]);
// Exports
module.exports = exports;
